module.exports = __webpack_public_path__ + "img/upload.1056cdd0.svg";